module.exports = __webpack_public_path__ + "static/media/logo.96f5d73f.png";